var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox"},[_c('a',{class:{ active: _vm.value },attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.update()}}},[(_vm.value)?_c('i',{staticClass:"fas fa-check-square"}):_c('i',{staticClass:"fas fa-square"})]),_c('div',{staticClass:"text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }